import { render, staticRenderFns } from "./CreateOrEditBanner.vue?vue&type=template&id=4f455b1f&scoped=true&"
import script from "./CreateOrEditBanner.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f455b1f",
  null
  
)

export default component.exports